export function init() {
  markup_favourites();
  window.markup_favourites = markup_favourites;
  window.get_favourites = get_favourites;
}

function get_favourites() {
  const cookies = document.cookie;

  // Find the cookie named 'favourite_ids'
  const favouriteCookie = cookies
    .split("; ")
    .find((cookie) => cookie.startsWith("favourite_properties="));

  let favourites = [];

  // If the 'favourite_ids' cookie is found
  if (favouriteCookie) {
    // Extract the value part (after '=')
    const value = favouriteCookie.split("=")[1];

    // Parse the JSON value into an array (assuming it is stored as a JSON array)
    try {
      favourites = JSON.parse(decodeURIComponent(value)); // Parse the value to get the list of favourite IDs

      return favourites;
    } catch (e) {
      console.error("Error parsing favourite_ids cookie:", e);
    }
  }

  return [];
}

function markup_favourites() {
  console.log("markup_favourites");
  let favourites = get_favourites();
  const favouriteElements = document.querySelectorAll(".favourite");
  favouriteElements.forEach(function (element) {
    const thispropertyid = element.getAttribute("data-id");
    let isFav = favourites.includes(thispropertyid);
    jQuery(element).on("click", function (e) {
      console.log("favourite clicked: ", thispropertyid);
      e.preventDefault();
      do_favourite(element);
    });
    if (isFav) {
      jQuery(element).addClass("active");
    } else {
      jQuery(element).removeClass("active");
    }
  });
}

function do_favourite(element) {
  const favourites = get_favourites();
  const thispropertyid = element.getAttribute("data-id");
  let isFav = favourites.includes(thispropertyid);

  if (isFav) {
    console.log("removing active");
    remove_from_favourite(thispropertyid);
    jQuery(element).removeClass("active");
  } else {
    console.log("adding active");
    append_to_favourites(thispropertyid);
    jQuery(element).addClass("active");
  }
}

function append_to_favourites(propertyid) {
  // console.log("append to favourite: ", propertyid)
  let favouriteIds = get_favourites();

  // Append the new item to the array
  favouriteIds.push(propertyid);

  // Save the updated array back to the cookie (as a JSON string)
  set_favourite_ids(favouriteIds);
}

function set_favourite_ids(propertyids) {
  let storethis = encodeURIComponent(JSON.stringify(propertyids));
  document.cookie = `favourite_properties=${storethis}; path=/; `;
}

function remove_from_favourite(propertyid) {
  let favouriteIds = get_favourites();
  favouriteIds = favouriteIds.filter((id) => id !== propertyid);
  set_favourite_ids(favouriteIds);
}

jQuery(window).on("load", function () {
  console.log("favourites init");

  init();
});
